interface SearchSuggestion {
    id: number;
    title: string;
    permalink: string;
}

async function getSuggestions(url: string, query: string): Promise<SearchSuggestion[]> {
    if (query.length < 3) {
        return [];
    }

    const response = await fetch(`${url}&s=${encodeURIComponent(query)}`);
    if (!response.ok) {
        throw new Error(`Error fetching suggestions: ${response.statusText}`);
    }
    const data = await response.json();
    if (!data || !Array.isArray(data.data)) {
        return [];
    }
    return data.data.map((item: any) => ({
        id: item.id,
        title: item.title,
        permalink: item.permalink,
    }));
}


function initSingleSearchForm(element:HTMLFormElement) {
    const searchInput = element.querySelector('input[type="text"]') as HTMLInputElement;
    const suggestionsContainer = element.querySelector('.pc-sp-search-suggestions') as HTMLElement;

    if (suggestionsContainer) {
        suggestionsContainer.style.display = 'none';
        const suggestionsList = suggestionsContainer.querySelector('ul') as HTMLUListElement;

        if (!suggestionsList) {
            // Clear previous suggestions
            console.error('Suggestions list not found');
        }
        suggestionsList.innerHTML = '';

        // Debounce to prevent too many backend requests
        let debounceTimeout: number | undefined;
        searchInput.addEventListener('keydown', (event) => {
            console.log('Keydown event detected');
            const query = searchInput.value.trim();

            if (debounceTimeout) {
            clearTimeout(debounceTimeout);
            }

            debounceTimeout = window.setTimeout(async () => {
            if (query.length < 3) {
                suggestionsContainer.style.display = 'none';
                return;
            }

            try {
                const suggestions = await getSuggestions('/wp-admin/admin-ajax.php?action=pc_sp_get_search_suggestions', query);
                if (suggestions.length > 0) {
                suggestionsList.innerHTML = suggestions.map(suggestion => `
                    <li class="py-1 px-2 hover:bg-gray-100"><a href="${suggestion.permalink}">${suggestion.title}</a></li>
                `).join('');
                suggestionsContainer.style.display = 'block';
                } else {
                suggestionsContainer.style.display = 'none';
                }
            } catch (error) {
                console.error('Error fetching suggestions:', error);
            }
            }, 300); // 300ms debounce
        });

        // outside click hides suggestions
        document.addEventListener('click', (event) => {
            if (!suggestionsContainer.contains(event.target as Node)) {
                suggestionsContainer.style.display = 'none';
            }
        });
    } else {
        console.warn('Search suggestions container not found');
    }
}


export function initPcPerksSearch(){
    const elements = document.querySelectorAll('.pc-sp-perks-search');
    elements.forEach((element) => {
        try {
            initSingleSearchForm(element as HTMLFormElement);
        } catch (error) {
            console.error('Error initializing search form:', error);
        }
    });
}

/**
 * HTML Template:
 * <form class="pc-sp-perks-search">
 *     <input type="search" placeholder="Search for perks..." />
 *     <button type="submit">Search</button>
 *     <div class="search-suggestions">
 *         <ul>
 *             <li><a href="#">Suggestion 1</a></li>
 *             <li><a href="#">Suggestion 2</a></li>
 *             <li><a href="#">Suggestion 3</a></li>
 *         </ul>
 *     </div>
 * </form>
 */